import request from '@/api/request.js'

// 新增
export function PaperDetailInsert(data) {
    return request({
        url: '/api/paper/paperdetailinsert',
        method: 'post',
        data: data
    })
}

// 删除
export function PaperDetailDelete(id) {
    return request({
        url: `/api/paper/paperdetaildelete/${id}`,
        method: 'post',
        data: {}
    })
}

// 更新
export function PaperDetailUpdate(id, data) {
    return request({
        url: `/api/paper/paperdetailupdate/${id}`,
        method: 'post',
        data: data
    })
}

// 获取
export function PaperDetailGetById(id) {
    return request({
        url: `/api/paper/getpaperdetailbyid/${id}`,
        method: 'get',
        data: {}
    })
}

// 获取列表
export function PaperDetailGetList(params) {
    return request({
        url: '/api/paper/getpaperdetaillist',
        method: 'get',
        params: params
    })
}

// 获取分页列表
export function PaperDetailGetPageList(params) {
    return request({
        url: '/api/paper/getpaperdetailpagelist',
        method: 'get',
        params: params
    })
}